import { Box, Button, Center, Text } from "@chakra-ui/react";
import React, { useMemo } from "react";
import ActivityPlate from "../components/activities/Activity";
import ActivityHeader from "../components/activities/ActivityHeader";
import ResourceProgress from "../components/utils/ResourceProgress";
import { Container, ScreenContainer, TailSpin } from "../components/wombat-ui";
import {
  ActivityFragment,
  useGetActivities,
} from "../graphql/generated/definitions";
import { useBreadcrumbs } from "../hooks/useBreadcrumbs";
import useTranslations from "../hooks/useTranslations";
import { getTimeAgoGroups, TimeAgoKeys } from "../utils/timeAgo";

const ActivityListScreen = () => {
  const t = useTranslations();
  useBreadcrumbs([]);

  const { data, loading, fetchMore } = useGetActivities({
    variables: {
      page: 1,
      per: 20,
      direction: "DESC",
      sortBy: "createdAt",
    },
    notifyOnNetworkStatusChange: true,
  });

  const activities = data?.activities?.collection || [];

  const sortedActivities = useMemo(
    () => getTimeAgoGroups<ActivityFragment>(activities),
    [activities]
  );

  return (
    <ScreenContainer>
      <ActivityHeader />
      <Container>
        <Box pb={6}>
          <Text fontSize="lg" fontWeight="semibold">
            {t("activity.header")}
          </Text>
          <Text fontSize="sm">{t("activity.description")}</Text>
        </Box>

        <ResourceProgress
          isLoading={loading}
          isEmpty={activities.length === 0}
          emptyMessage={t("activity.nothing") as string}
        />

        <div>
          {sortedActivities ? (
            TimeAgoKeys.map(
              (timeAgo: string) =>
                sortedActivities[timeAgo].length > 0 && (
                  <div id={timeAgo} key={timeAgo}>
                    <Box
                      fontSize="sm"
                      fontWeight="bold"
                      bg="gray.100"
                      w="100%"
                      py={1}
                      px={3}
                      borderRadius="md"
                      color="dark.100"
                    >
                      {t(`activity.${timeAgo}`) as string}
                    </Box>
                    <div className="py-6">
                      {sortedActivities[timeAgo].map(
                        (activity: ActivityFragment) => (
                          <ActivityPlate
                            activity={activity}
                            key={activity.id}
                          />
                        )
                      )}
                    </div>
                  </div>
                )
            )
          ) : (
            <p className="text-sm">{t("activity.nothing")}</p>
          )}
        </div>
        <Center alignContent="center">
          {data?.activities?.metadata?.totalCount > activities.length && (
            <Button
              id="seeMore"
              onClick={() => {
                fetchMore({
                  variables: {
                    page: data?.activities?.metadata?.currentPage + 1,
                  },
                });
              }}
            >
              {loading ? (
                <TailSpin className="w-5 h-5" />
              ) : (
                t("activity.seeMore")
              )}
            </Button>
          )}
        </Center>
      </Container>
    </ScreenContainer>
  );
};

export default ActivityListScreen;
